import React, {useContext, useEffect, useState, useRef, useCallback} from 'react'
import {
  IconButton,
  Popover,
  Checkbox,
  Typography,
  TextField,
  Grid,
  CircularProgress,
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import SearchIcon from '@material-ui/icons/Search'
import Button from '@material-ui/core/Button'
import InputAdornment from '@material-ui/core/InputAdornment'
import CloseIcon from '@material-ui/icons/Close'
import CheckIcon from '@material-ui/icons/Check'

import {ReservationContext} from '../../../../../context/Reservation'
import {normalizeFieldValues} from './utils'
import useCalendarViewContext from '../../../../../context/CalendarView'
import LoadingIcon from '../../loading.gif'

const FilterFieldItems = ({
  options,
  handleClickValueOption,
  value,
  values,
  field,
  objects,
  setSelectedFilters,
}) => {
  const {sharableFilterFieldValues, loadSharableFilterFieldValues} = useCalendarViewContext()
  const [isSearching, setSearching] = useState(false)
  const [normalizedValues, setNormalizedValues] = useState([])
  const [selectableValues, setSelectableValues] = useState([])
  const [selectedValues, setSelectedValues] = useState([])
  const [search, setSearch] = useState('')
  const refFieldValuesScroll = useRef(null)
  const [realSearch, setRealSearch] = useState('')
  const [stillLoading, setStillLoading] = useState(true)
  const refSearch = useRef(null)

  useEffect(() => {
    if (field.field_id || field.id) {
      loadSharableFilterFieldValues(field.field_id || field.id, realSearch, {limit: 50, page: 1})
    }
    const el = refFieldValuesScroll.current
    if (el) {
      el.scrollTop = 0
    }
  }, [field, realSearch, loadSharableFilterFieldValues])

  useEffect(() => {
    if (values.length) {
      let exists = false
      values.map(o => {
        if (o.id === (field.field_id || field.id)) {
          exists = true
          setSelectedValues([...o.value])
        }
        return true
      })
      if (!exists) {
        setSelectedValues([])
      }
    } else {
      setSelectedValues([])
    }
  }, [values, field])

  useEffect(() => {
    const el = refFieldValuesScroll.current
    const handleScrollEvent = e => {
      if (
        Math.round(e.target.offsetHeight + e.target.scrollTop) >= Math.round(e.target.scrollHeight)
      ) {
        if (
          !sharableFilterFieldValues.isLoading &&
          sharableFilterFieldValues?.data.page < sharableFilterFieldValues?.data.total_objects / 50
        ) {
          loadSharableFilterFieldValues(field.field_id || field.id, realSearch, {
            page: sharableFilterFieldValues?.data.page + 1,
            limit: 50,
          })
        }
      }
    }
    if (el) {
      el.addEventListener('scroll', handleScrollEvent)
    }
    return () => {
      if (el) {
        el.removeEventListener('scroll', handleScrollEvent)
      }
    }
  }, [
    refFieldValuesScroll,
    sharableFilterFieldValues,
    loadSharableFilterFieldValues,
    realSearch,
    field.field_id,
    field.id,
  ])

  useEffect(() => {
    let _selectableValues = []

    let normalizedValues = normalizeFieldValues(
      sharableFilterFieldValues.data.field_type,
      sharableFilterFieldValues.data.values
    )
    setNormalizedValues([
      {label: 'Select All ', value: 'select_all'},
      {label: 'No Value', value: 'no_value'},
      ...normalizedValues,
    ])

    let tNormalizedValues = [
      {label: 'Select All ', value: 'select_all'},
      {label: 'No Value', value: 'no_value'},
      ...normalizedValues,
    ]
    tNormalizedValues.map(f => {
      if (!selectedValues.includes(f.value)) {
        _selectableValues.push(f)
      }
      return true
    })
    setSelectableValues([..._selectableValues])
  }, [selectedValues, sharableFilterFieldValues])

  const tryCallApi = useCallback(() => {
    setStillLoading(false)
    // eslint-disable-next-line
  }, [realSearch])

  const handleSearchText = e => {
    e.preventDefault()
    setSearch(e.target.value)
    if (e.target.value === '') {
      setRealSearch('')
    }
  }

  const handleSearch = e => {
    if ('Enter' === e.key) {
      setRealSearch(search)
    } else {
      setSearching(true)
    }
  }

  const onCloseSearch = () => {
    refSearch.current.focus()
    setSearch('')
    setRealSearch('')
    setSearching(true)
  }

  return (
    <>
      <div
        className={`${selectedValues.length === 0 &&
          'value-main-container-max-height'} c-res-mod ap-list overflow-hodden value-main-container`}
      >
        <Grid container style={{position: 'relative'}} xs={12}>
          {isSearching ? (
            <Grid item xs={10} className="search-option-body-gantt-filter-items">
              <TextField
                onBlur={() => {
                  isSearching === true && search === '' ? setSearching(false) : setSearching(true)
                }}
                id="standard-basic"
                type="text"
                className="c-res-mod ap-list"
                autoFocus
                value={search}
                onChange={handleSearchText}
                onKeyDown={e => handleSearch(e)}
                inputRef={refSearch}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <div isDisabled={true}>
                        <CloseIcon style={{cursor: 'pointer'}} onClick={onCloseSearch} /> |{' '}
                      </div>
                      <IconButton
                        type="submit"
                        className="ap-icon-button"
                        underline={false}
                        aria-label="search"
                        style={{padding: 0}}
                        onClick={() => {
                          if (isSearching === true && search.length !== 0) {
                            setRealSearch(search)
                          } else {
                            setSearching(true)
                          }
                        }}
                      >
                        <SearchIcon className="filter-search-icon" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          ) : (
            <Grid xs={10} style={{position: 'absolute', right: '0px', top: '-1px'}}>
              <Typography
                style={{position: 'absolute', right: '112px'}}
                className="font-16 field-value-text"
              >
                Value
              </Typography>
              <IconButton
                type="submit"
                className="ap-icon-button"
                underline={false}
                aria-label="search"
                style={{padding: 0}}
                onClick={() => {
                  if (isSearching === true) {
                    if (search.startsWith('#')) {
                      let newSearch = search.substring(1)
                      setRealSearch(newSearch)
                    } else {
                      setRealSearch(search)
                    }
                  } else {
                    setSearching(true)
                  }
                }}
              >
                <SearchIcon className="filter-search-icon" />
              </IconButton>
            </Grid>
          )}
        </Grid>

        {(field.field_id || field.id) && !sharableFilterFieldValues.isLoading ? (
          <div className="height-100-per">
            <div
              style={{position: 'relative'}}
              // onClick={e => handleSelectAllCheckbox(e)}
            ></div>
            <div
              className={`${
                selectedValues.length === 0 ? 'heigh-90-per' : 'heigh-80-per'
              } ap-list__wrapper scroll-bar-style values-list-container`}
            >
              {selectableValues.length > 0 ? (
                selectableValues.map((o, i) => (
                  <div
                    key={i}
                    className={`word-break-all filter-item-list ap-list__item ap-typography ap-typography--sm ap-flex ap-flex--start ap-flex--align-center c-pop-field-toggle__option
                `}
                    style={{cursor: 'pointer'}}
                    onClick={e => handleClickValueOption(e, o.value, o)}
                  >
                    {o.label}
                  </div>
                ))
              ) : (
                <Typography
                  className={`filter-item-list ap-list__item ap-typography ap-typography--sm ap-flex ap-flex--start ap-flex--align-center c-pop-field-toggle__option
                `}
                >
                  No value
                </Typography>
              )}
            </div>
          </div>
        ) : (
          sharableFilterFieldValues.isLoading && (
            <div className="field-loading-icon-container">
              <img alt="LoadingIcon" src={LoadingIcon} className="field-loading-icon" />
            </div>
          )
        )}
      </div>
      <div className="c-res-mod ap-list selected-item-list-container">
        {selectedValues.length > 0 && (
          <div className="selcted-heading">
            <Grid container>
              <Grid item xs={10}>
                <Typography className="ap-typography--sm font-16 field-value-text">
                  Selected
                </Typography>
              </Grid>
            </Grid>
          </div>
        )}

        {field && (
          <div className="ap-selected-values selected-values scroll-bar-style">
            {values &&
              normalizedValues.map((o, i) => {
                let rep_value = false
                if (typeof o.value === 'string' && o.value.includes(' ')) {
                  let id_value = o.value.replace(' ', '_')
                  rep_value = selectedValues.includes(id_value)
                }
                if (selectedValues.includes(o.value) || rep_value) {
                  return (
                    <div
                      key={i}
                      className={`word-break-all ap-typography ap-typography--sm ap-ellipsis`}
                      style={{cursor: 'pointer', color: '#3473ff', fontSize: 12}}
                      onClick={e => handleClickValueOption(e, o.value, o)}
                    >
                      <CheckIcon style={{width: 24, padding: 4, marginRight: 8}} />
                      <span>{o.label}</span>
                    </div>
                  )
                } else return null
              })}
          </div>
        )}
      </div>
    </>
  )
}

export default FilterFieldItems
